import { Helpers } from '../../helpers';
import { IItemAttribute } from '../../interfaces/iitem-attribute';
import { ItemAttributeRateKey } from '../item-attribute-rate-key';
import { ItemAttributeResourceCalculationKey } from '../item-attribute-resource-calculation-key';
import { ItemAttributesMapping } from '../item-attributes-mapping';

export class ItemAttributeBase {
  ItemAttributeId: number;
  Name: string;
  Value: string;
  LastUpdatedDate: Date;
  LastUpdatedUser: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ItemAttributeRateKeys_ItemAttribute?: Array<ItemAttributeRateKey> | null;
  ItemAttributeResourceCalculationKeys_ItemAttribute?: Array<ItemAttributeResourceCalculationKey> | null;
  ItemAttributesMapping_ItemAttribute?: Array<ItemAttributesMapping> | null;

  constructor(item?: IItemAttribute) {
    if (item) {

      this.ItemAttributeId = item.ItemAttributeId;
      this.Name = item.Name;
      this.Value = item.Value;
      this.LastUpdatedDate = item.LastUpdatedDate ? new Date(item.LastUpdatedDate) : null;
      this.LastUpdatedUser = item.LastUpdatedUser;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ItemAttributeRateKeys_ItemAttribute = Helpers.createClassArray(ItemAttributeRateKey, item.ItemAttributeRateKeys_ItemAttribute);
      this.ItemAttributeResourceCalculationKeys_ItemAttribute = Helpers.createClassArray(ItemAttributeResourceCalculationKey, item.ItemAttributeResourceCalculationKeys_ItemAttribute);
      this.ItemAttributesMapping_ItemAttribute = Helpers.createClassArray(ItemAttributesMapping, item.ItemAttributesMapping_ItemAttribute);
    }
  }
}